module.exports = __webpack_public_path__ + "static/media/oberflex-wenge-1200x2490.a16eb851.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-wenge-1200x2490.jpg
// module id = 1062
// module chunks = 37